// Modal para adicionar um Autor existente ao processo.

import React from "react";
import axios from "axios";

const NovoAutorModal = ({ idProcess, token, responsePessoa }) => {

    function cadastrarAutor() {
        const autor = document.querySelector("#nomeAutor").value;

        axios
            .post(
                `/api/new/actor/${idProcess}`,
                { token, autor },
                {
                    withCredentials: true,
                }
            )
            .then((resp) => {
                if (resp.data == 400) {
                    alert("Essa pessoa já está cadastrada como Autor!");
                } else {
                    window.location = `/ci/pagamentos/${idProcess}`;
                }
            });
    }

    return (
        <div
            className="modal fade"
            id="novoautor"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">
                            Novo Autor
                        </h5>
                        <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <label htmlFor="m-cadastrar-descricaoLbl">
                            Selecione a Pessoa
                        </label>
                        <select
                            className="form-control select2 select2-hidden-accessible"
                            style={{
                                width: "100%",
                                position: "static !important",
                            }}
                            name="autor"
                            id="nomeAutor"
                        >
                            {responsePessoa.map((dados, index) => (
                                <option key={index}>{dados.nome}</option>
                            ))}
                        </select>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            data-dismiss="modal"
                        >
                            Fechar
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={cadastrarAutor}
                        >
                            Salvar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NovoAutorModal;
